<template>
  <div>
    <!-- 操作按钮取 -->
    <div class="btns-bar">
      <el-button type="primary" @click="openAddDialog">添加通知</el-button>
    </div>
    <!-- 表格展示 -->
    <el-table :data="tableData" style="width: 100%">
      <el-table-column type="index" width="50"> </el-table-column>
      <el-table-column prop="_id" label="通知ID" width="230">
        <template slot-scope="scope">
          <copy-text :value="scope.row._id"></copy-text>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="通知标题" width="300"></el-table-column>
      <el-table-column prop="content" label="通知内容" width="500"></el-table-column>
      <el-table-column prop="type" label="通知类型" width="120">
        <template slot-scope="scope">
          <span>{{ getTypeName(scope.row.type) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="通知指向链接" width="200"></el-table-column>
      <el-table-column label="操作" :width="isMobile ? 64 : 120" fixed="right">
        <template slot-scope="scope">
          <div class="table-actions">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="openEditDialog(scope.row)"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="handleDelete(scope.row._id)"
            ></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="total > 0"
      class="pager"
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="pageSize"
      :current-page.sync="pageNum"
      @current-change="onCurrentPageChange"
    >
    </el-pagination>
    <!-- 添加/修改对话框 -->
    <el-dialog
      :title="isEdit ? '修改通知' : '添加通知'"
      :visible.sync="showDialog"
      width="50%"
      custom-class="mobile-form-dialog"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="通知标题" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="通知内容" prop="content">
          <el-input type="textarea" autosize v-model="form.content"></el-input>
        </el-form-item>
        <el-form-item label="通知类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="0">赛事上新通知</el-radio>
            <el-radio :label="1">官方通知</el-radio>
            <el-radio :label="2">报名截止通知</el-radio>
            <el-radio :label="3">赛事优惠通知</el-radio>
            <el-radio :label="4">赛事延期/取消通知</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="通知指向链接" prop="url">
          <event-link-autocomplete v-model="form.url"></event-link-autocomplete>
          <div class="url-hint">
            支持以下格式：<br/>
            1. 小程序页面路径（带 / 开头）：<span class="url-example">/pages/brandDetail/brandDetail?value=huanji</span><br/>
            2. 微信公众号文章链接：<span class="url-example">https://mp.weixin.qq.com/s/xxx</span><br/>
            3. 官网H5链接（WebView打开）：<span class="url-example">https://www.musclegame.cn/xxx</span><br/>
            4. 赛事ID（直接填写，跳转赛事详情）：<span class="url-example">65a0f3ed8e443fe4d49aff9c</span>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EventLinkAutocomplete from '../../components/EventLinkAutocomplete.vue';

export default {
  components: {
    EventLinkAutocomplete
  },
  data() {
    return {
      showDialog: false,
      isEdit: false,
      editId: null,
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 20,
      form: {
        title: "",
        content: "",
        type: 0,
        url: ""
      },
      isMobile: false,
      rules: {
        title: [
          { required: true, message: "请输入通知标题", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        content: [
          { required: true, message: "请输入通知内容", trigger: "blur" },
          {
            min: 3,
            max: 500,
            message: "长度在 3 到 500 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getNoticeList()
  },
  mounted() {
    this.updateViewport();
    window.addEventListener('resize', this.updateViewport);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewport);
  },
  methods: {
    updateViewport() {
      this.isMobile = window.innerWidth <= 768;
    },
    getTypeName(type) {
      const typeMap = {
        0: '赛事上新',
        1: '官方通知',
        2: '报名截止',
        3: '赛事优惠',
        4: '延期/取消'
      };
      return typeMap[type] || '未知';
    },
    getNoticeList() {
      this.$axios.get(`/notice/find_all?page=${this.pageNum}&pageSize=${this.pageSize}`).then((res) => {
        // 后端返回结构: { code, message, res: { res: [...], total: 42 } }
        const data = res.data.res || res.data;
        this.tableData = Array.isArray(data.res) ? data.res : (Array.isArray(data) ? data : []);
        this.total = data.total || 0;
      }).catch((err) => {
        this.$message.error(err.response.data.message);
      })
    },
    onCurrentPageChange(page) {
      this.pageNum = page;
      this.getNoticeList();
    },
    openAddDialog() {
      this.isEdit = false;
      this.editId = null;
      this.form = {
        title: "",
        content: "",
        type: 0,
        url: ""
      };
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    openEditDialog(row) {
      this.isEdit = true;
      this.editId = row._id;
      this.form = {
        title: row.title,
        content: row.content,
        type: row.type,
        url: row.url || ""
      };
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    handleSubmit() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return this.$message.error("表单信息填写错误，请根据提示检查！");
        }
        if (this.isEdit) {
          this.updateNotice();
        } else {
          this.addNotice();
        }
      });
    },
    addNotice() {
      this.$axios
        .post('/notice/add',
        JSON.stringify(this.form),
        {
          headers: {
            'x-auth-token': localStorage.getItem('bde_token')
          }
        })
        .then((res) => {
          if (res.data.code === "success") {
            this.$message.success("添加成功！");
            this.showDialog = false;
            this.getNoticeList();
          } else {
            this.$message.error("请求错误！");
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        })
    },
    updateNotice() {
      this.$axios
        .post('/notice/update',
        JSON.stringify({ id: this.editId, ...this.form }),
        {
          headers: {
            'x-auth-token': localStorage.getItem('bde_token')
          }
        })
        .then((res) => {
          if (res.data.res && res.data.res._id) {
            this.$message.success("修改成功！");
            this.showDialog = false;
            this.getNoticeList();
          } else {
            this.$message.error("请求错误！");
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        })
    },
    handleDelete(id) {
      this.$confirm("此操作将永久删除该通知, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.requestDelete(id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    requestDelete(id) {
      this.$axios
        .post('/notice/delete',
        JSON.stringify({id: id}),
        {
          headers: {
            "x-auth-token": localStorage.getItem("bde_token"),
          },
        })
        .then((res) => {
          if (res.data.code === "success") {
            this.$message.success("删除成功");
            this.getNoticeList();
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
          if(err.response.data.code === 'token_timeout') {
            this.$router.push('/login')
          }
        });
    },
  }
};
</script>

<style scoped>
.btns-bar {
  margin: 20px 0;
}
.tip {
  margin-top: 20px;
  font-size: 14px;
  color: #999;
}
.pager {
  margin-top: 20px;
}
.url-hint {
  font-size: 12px;
  color: var(--text-secondary, #909399);
  line-height: 1.8;
  margin-top: 6px;
}
.url-example {
  color: var(--brand-primary, #c04851);
  font-family: 'Courier New', Courier, monospace;
  background-color: var(--bg-table-hover, #f5f7fa);
  padding: 1px 6px;
  border-radius: 3px;
}
.table-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.table-actions .el-button {
  margin: 0;
}

@media (max-width: 768px) {
  .table-actions {
    flex-direction: column;
    align-items: center;
  }
}
</style>
